/**
 * @constructor
 *
 * Some events need to run when a user logs in.
 * There is a USER_LOGGED_IN event broadcast on $rootScope for that, but that may fire fired when a user has logged in
 * but before a device has been selected.
 *
 * If you want code to run when the device is ready to use, meaning we have a user logged in and a device set,
 * you can use this class.
 *
 * Usage:
 * container.deviceLoginListener.addListener(() => {
 *    // Do something when the device is ready to use.
 * });
 *
 * @param {CurrentDevice} currentDevice
 * @param {UserService} userService
 */
const DeviceLoginListener = function (
    currentDevice,
    userService
) {
    this.currentDevice = currentDevice;
    this.userService = userService;

    /**
     * @type {Function[]}
     */
    this.listeners = [];

    this.deviceRequired = true;
};

DeviceLoginListener.prototype = {
    /**
     * @param {Function} func
     */
    addListener(func) {
        this.listeners.push(func);
    },

    /**
     * @private
     */
    runListeners() {
        this.listeners.forEach((func) => func());
    },

    trigger() {
        if (
            this.userService.isLoggedIn()
            && (!this.deviceRequired || this.currentDevice.isSet())
        ) {
            this.runListeners();
        }
    },

    /**
     * Some apps (kitchen, kitchen-customer) don't use devices.
     * Call this method on those to skip the device check and still allow listeners to run when a user logs in.
     *
     * @param {boolean} value
     */
    setDeviceRequired(value) {
        this.deviceRequired = value;
    },

};

module.exports = DeviceLoginListener;
